(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gp-homepage-slideshow"] && !Shopify.designMode) return;
  try {
    
  class GPHomepageSlideshow extends HTMLElement {
    connectedCallback() {
      this.slideshow = this.querySelector('slideshow-component');
      if (!this.slideshow) return;

      this.resizeObserver = new ResizeObserver(() => {
        cancelAnimationFrame(this.resizeFrame);
        this.resizeFrame = requestAnimationFrame(() => this.alignCurrentSlide());
      });
      this.resizeObserver.observe(this);
    }

    disconnectedCallback() {
      this.resizeObserver?.disconnect();
      cancelAnimationFrame(this.resizeFrame);
    }

    alignCurrentSlide() {
      const scroller = this.slideshow?.refs?.scroller;
      const slides = this.slideshow?.slides;
      const currentSlide = slides?.[this.slideshow.current] || slides?.[0];
      if (!scroller || !currentSlide) return;

      const target = currentSlide.offsetLeft - (scroller.clientWidth - currentSlide.offsetWidth) / 2;
      if (Math.abs(scroller.scrollLeft - target) > 1) {
        scroller.scrollTo({ left: target, behavior: 'auto' });
      }
    }
  }

  if (!customElements.get('gp-homepage-slideshow')) {
    customElements.define('gp-homepage-slideshow', GPHomepageSlideshow);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
